export const ApiInterceptorModule = angular
    .module('app.services.apiInterceptor', [
        'ngRaven'
    ]).factory('apiInterceptor', (
        $q,
        $location,
        $cookies,
        auth0SdkService,
    ) => {
        function useUniversalLogin() {
            return /myvolusion.com|volusionplatformdev.com|localhost|127.0.0.1$/.test($location.host());
        }

        return {
            requestError(rejection) {
                return $q.reject(rejection);
            },

            responseError(rejection) {
                return $q.reject(rejection);
            },

            request: (config) => {
                if (!config.skipAuthorization) {
                    if (useUniversalLogin()) {
                        return auth0SdkService.getTokenSilently().then((accessToken) => {
                            config.headers.Authorization = `Bearer ${accessToken}`;
                            return config;
                        }).catch(() => {
                            return config;
                        });
                    }

                    const token = $cookies.get('id_token', {
                        secure: true,
                        path: '/'
                    });

                    config.headers.Authorization = `Bearer ${token}`;
                    return $q.resolve(config);
                }
                return config;
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/api.interceptor.js